import DemoRenderer__LegacyDemoInstructions from '@runtime/DemoRenderer';
import InterfaceRenderer__LinkInstructions from '@runtime/TypescriptMetadataRenderer/interface';
import DemoRenderer__LinkInstructions from '@runtime/DemoRenderer';
import legacyImportDemo_2267038447 from "../../../../../packages/component/src/components/button/demo/demo1.js?loadDemo";
import legacyImportDemo_2908874028 from "../../../../../packages/component/src/components/button/demo/demo2.js?loadDemo";
import legacyImportDemo_1212040301 from "../../../../../packages/component/src/components/button/demo/demo3.js?loadDemo";
import * as React from 'react';
export default {
  DemoRenderer__LegacyDemoInstructions,
  InterfaceRenderer__LinkInstructions,
  DemoRenderer__LinkInstructions,
  legacyImportDemo_2267038447,
  legacyImportDemo_2908874028,
  legacyImportDemo_1212040301,
  React
};